import styles from '../PersonCard/PersonCard.module.css';
import {
  GiBasketballBall,
  GiAmericanFootballBall,
  GiSoccerBall,
  GiVolleyballBall,
  GiTennisBall,
  GiBaseballGlove
} from 'react-icons/gi';

const sportIcons = {
  basketball: <GiBasketballBall />,
  football: <GiAmericanFootballBall />,
  soccer: <GiSoccerBall />,
  volleyball: <GiVolleyballBall />,
  tennis: <GiTennisBall />,
  baseball: <GiBaseballGlove />
};

const AthleteCard = ({ athlete, onClick }) => {
  const { firstName, lastName, sports = [], profilePicture } = athlete;
  const sport = sports[0] || 'basketball';
  const icon = sportIcons[sport] || <GiBasketballBall />;
  const fullName = `${firstName} ${lastName}`;
  const profileImage = profilePicture || '/images/avatar-boy-svgrepo-com.svg';

  return (
    <div className={styles.card} onClick={() => onClick?.(athlete)}>
      <img
        src={profileImage}
        alt={fullName}
        className={styles.profilePic}
        onError={(e) => { e.target.src = '/images/avatar-boy-svgrepo-com.svg'; }}
      />
      <div className={styles.name}>{fullName}</div>
      <div className={styles.icon}>{icon}</div>
    </div>
  );
};

export default AthleteCard;
